<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        :checkedCount="checkedCount"
        @clearCheckboxRow="clearCheckboxRow"
        @exportData="exportData"
        @updateSalePerson="updateSalePerson"
        @updateDesigner="updateDesigner"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :title="$l('INDEX.dialog_title_select_export_template') || '选择导出模版'"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: chooseTemplateOptions.exportParams,
      }"
      @close="closeChooseTemplate"
      @confirmClose="confirmClose"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import ChooseTemplate from '@/views/backstage/components/choose-template'
import { getLang } from '@/libs/util.lang'
export default {
  components: { PageHeader, PageMain, ChooseTemplate },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      checkedRow: [],
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'admin-sampleInfo',
        exportParams: {
          sampleCodeList: [],
          language: getLang(),
        },
      },
    }
  },
  activated() {
    this.reload()
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sampleInfoListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    exportData() {
      const exportParams = this.$refs.main.exportData()
      if (!exportParams) {
        return
      }
      this.chooseTemplateOptions = {
        visible: true,
        templateGroup: 'admin-sampleInfo',
        exportParams: {
          ...exportParams,
          language: getLang(),
        },
      }
    },
    closeChooseTemplate() {
      this.chooseTemplateOptions.visible = false
    },
    confirmClose() {
      this.closeChooseTemplate()
      this.$refs.main.removeCheckBox()
    },
    clearCheckboxRow() {
      this.$refs.main.removeCheckBox()
    },
    updateSalePerson() {
      this.$refs.main.updateSalePerson()
    },
    updateDesigner() {
      this.$refs.main.updateDesigner()
    },
  },
}
</script>
